<template>
    <div class="product__item-grid">
        <vps-plan
            v-if="vpsPlans"
            v-for="vpsPlan in vpsPlans"
            :key="vpsPlan.name"
            :productPlan="vpsPlan"
            :domain="domain"
        />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import VpsPlan from '../vps/VpsPlan.vue';

    export default {
        components: {
            VpsPlan
        },
        props: {
            domain: Object
        },
        computed: {
            ...mapGetters({
                vpsPlans: 'products/vpsPlans'
            })
        }
    };
</script>
